export const getStickyValue = () => {
    const node = document.createElement('a');
    node.style.cssText = 'position: fixed; position: -webkit-fixed';

    return node.style.position;
};

export const isSupported = getStickyValue() === 'sticky' || getStickyValue() === '-webkit-fixed';
